// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"542ae8f5","261":"6e77fc8a","338":"e626b481","456":"8b9c66b0","541":"894c9bec","544":"3c66ba7b","576":"789f4e21","753":"d227d475","775":"4bf5155f","823":"58ddd048","980":"884c24c8"}[chunkId] + ".js";
};